import React from 'react';
import { Waves, Smartphone, Signal, Zap } from 'lucide-react';

const providers = [
  { name: 'Wave', color: '#1B6BF7', Icon: Waves },
  { name: 'Orange Money', color: '#FF6B00', Icon: Signal },
  { name: 'MTN MoMo', color: '#F8C108', Icon: Smartphone },
  { name: 'Moov Money', color: '#3DBA75', Icon: Zap },
];

export default function PaymentSection() {
  return (
    <section id="payments" className="relative">
      <div className="bg-[#1f2421] text-white">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <div className="grid lg:grid-cols-2 gap-10 items-start">
            <div>
              <div className="text-[11px] tracking-[0.18em] uppercase font-medium text-white/60">Mobile Money</div>
              <h2 className="mt-2 text-[clamp(2rem,4vw,3.4rem)] leading-[1.05] font-semibold tracking-tight">
                Les moyens de paiement <br /> que <span className="serif-italic text-amber-300">tout le monde</span> utilise.
              </h2>
              <p className="mt-5 max-w-xl text-[15px] text-white/70 leading-relaxed">
                Aucune carte bancaire requise. Tous vos amis et votre famille peuvent contribuer avec leur téléphone, en quelques secondes.
              </p>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
              {providers.map(({ name, color, Icon }) => (
                <div key={name} className="rounded-2xl bg-white/5 border border-white/10 hover:bg-white/10 backdrop-blur p-5 flex flex-col items-start gap-3 card-lift">
                  <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: `${color}20`, color }}>
                    <Icon className="w-5 h-5" />
                  </div>
                  <div className="text-[14.5px] font-medium">{name}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
